import script from "./ImageFullscreenOverlay.vue?vue&type=script&setup=true&lang=ts"
export * from "./ImageFullscreenOverlay.vue?vue&type=script&setup=true&lang=ts"

import "./ImageFullscreenOverlay.vue?vue&type=style&index=0&id=9b276aa8&lang=css"

const __exports__ = script;

export default __exports__